module.exports = __webpack_public_path__ + "img/conectasus.244e441c.png";